/**
 * Do not edit directly
 * Generated on Fri, 04 Jul 2025 11:07:12 GMT
 */

export const colorSemanticSurfaceDisabled = "rgba(18, 21, 17, 0.1)";
export const colorSemanticSurfaceForegroundDisabled = "rgba(18, 21, 17, 0.3)";
export const colorSemanticSurfaceForegroundDefault = "#2d2f29";
export const colorSemanticSurfaceForegroundSubtle = "#605e56";
export const colorSemanticSurfaceForegroundInverted = "#fffffe";
export const colorSemanticSurfaceDefault = "#fffffe";
export const colorSemanticSurfaceAlt = "#f3f0ec";
export const colorSemanticSurfaceInverted = "#121511";
export const colorSemanticSurfaceBackgroundDefault = "#f9f8f5";
export const colorSemanticDataNeutralEmpty = "rgba(18, 21, 17, 0.1)";
export const colorSemanticDataNeutralTransparent = "rgba(176, 170, 165, 0.3)";
export const colorSemanticDataNeutralDefault = "#938e89";
export const colorSemanticDataNeutralLowest = "#e9e4e0";
export const colorSemanticDataNeutralPast = "#c6c0bb";
export const colorSemanticDataNeutralGradient = "linear-gradient(#938e894d 0%,#938e8900 100%)";
export const colorSemanticDataStarRating0Default = "#8d8d8f";
export const colorSemanticDataStarRating0Surface = "#d1d1d4";
export const colorSemanticDataStarRating0Foreground = "#535355";
export const colorSemanticDataStarRating0Gradient = "linear-gradient(#8d8d8f4d 0%,#8d8d8f00 100%)";
export const colorSemanticDataStarRating1Default = "#d6341f";
export const colorSemanticDataStarRating1Surface = "#ffc4b4";
export const colorSemanticDataStarRating1Foreground = "#722b1f";
export const colorSemanticDataStarRating1Gradient = "linear-gradient(#d6341f4d 0%,#d6341f00 100%)";
export const colorSemanticDataStarRating2Default = "#e86602";
export const colorSemanticDataStarRating2Surface = "#fdeee4";
export const colorSemanticDataStarRating2Foreground = "#5d3c23";
export const colorSemanticDataStarRating2Gradient = "linear-gradient(#e866024d 0%,#e8660200 100%)";
export const colorSemanticDataStarRating3Default = "#d9a600";
export const colorSemanticDataStarRating3Surface = "#fff0c1";
export const colorSemanticDataStarRating3Foreground = "#4d4325";
export const colorSemanticDataStarRating3Gradient = "linear-gradient(#d9a6004d 0%,#d9a60000 100%)";
export const colorSemanticDataStarRating4Default = "#59a413";
export const colorSemanticDataStarRating4Surface = "#e4f7d9";
export const colorSemanticDataStarRating4Foreground = "#314a1c";
export const colorSemanticDataStarRating4Gradient = "linear-gradient(#59a4134d 0%,#59a41300 100%)";
export const colorSemanticDataStarRating5Default = "#00a06a";
export const colorSemanticDataStarRating5Surface = "#95e2b8";
export const colorSemanticDataStarRating5Foreground = "#1e4b36";
export const colorSemanticDataStarRating5Gradient = "linear-gradient(#00a06a4d 0%,#00a06a00 100%)";
export const colorSemanticDataBiasedPositiveDefault = "#31852f";
export const colorSemanticDataBiasedPositiveHighest = "#1d521c";
export const colorSemanticDataBiasedPositiveHigh = "#31852f";
export const colorSemanticDataBiasedPositiveMedium = "#57b454";
export const colorSemanticDataBiasedPositiveLow = "#b5e6ab";
export const colorSemanticDataBiasedPositiveLowest = "#e3fadc";
export const colorSemanticDataBiasedPositiveGradient = "linear-gradient(#31852f4d 0%,#31852f00 100%)";
export const colorSemanticDataBiasedPositiveTransparent = "rgba(49, 133, 47, 0.3)";
export const colorSemanticDataBiasedNegativeDefault = "#c04351";
export const colorSemanticDataBiasedNegativeHighest = "#82222b";
export const colorSemanticDataBiasedNegativeHigh = "#c04351";
export const colorSemanticDataBiasedNegativeMedium = "#fb737f";
export const colorSemanticDataBiasedNegativeLow = "#ffc6c0";
export const colorSemanticDataBiasedNegativeLowest = "#ffece8";
export const colorSemanticDataBiasedNegativeGradient = "linear-gradient(#c043514d 0%,#c0435100 100%)";
export const colorSemanticDataBiasedNegativeTransparent = "rgba(192, 67, 81, 0.3)";
export const colorSemanticDataBiasedGradient = "linear-gradient(90deg, #82222b 0%, #e9e4e0 50%, #1d521c 100%)";
export const colorSemanticDataComparativeMulti1 = "#a15494";
export const colorSemanticDataComparativeMulti2 = "#ed8366";
export const colorSemanticDataComparativeMulti3 = "#d56b7b";
export const colorSemanticDataComparativeMulti4 = "#42b1a5";
export const colorSemanticDataComparativeMulti5 = "#af5741";
export const colorSemanticDataComparativeMulti6 = "#933d4c";
export const colorSemanticDataComparativeMulti7 = "#25655f";
export const colorSemanticDataComparativeMulti8 = "#85934d";
export const colorSemanticDataComparativeMulti9 = "#67345d";
export const colorSemanticDataComparativeMulti10 = "#576030";
export const colorSemanticDataComparativeMultiGradient1 = "linear-gradient(#a154944d 0%,#a1549400 100%)";
export const colorSemanticDataComparativeMultiGradient2 = "linear-gradient(#ed83664d 0%,#ed836600 100%)";
export const colorSemanticDataComparativeMultiGradient3 = "linear-gradient(#d56b7b4d 0%,#d56b7b00 100%)";
export const colorSemanticDataComparativeMultiGradient4 = "linear-gradient(#42b1a54d 0%,#42b1a500 100%)";
export const colorSemanticDataComparativeMultiGradient5 = "linear-gradient(#af57414d 0%,#af574100 100%)";
export const colorSemanticDataComparativeMultiGradient6 = "linear-gradient(#933d4c4d 0%,#933d4c00 100%)";
export const colorSemanticDataComparativeMultiGradient7 = "linear-gradient(#25655f4d 0%,#25655f00 100%)";
export const colorSemanticDataComparativeMultiGradient8 = "linear-gradient(#85934d4d 0%,#85934d00 100%)";
export const colorSemanticDataComparativeMultiGradient9 = "linear-gradient(#67345d4d 0%,#67345d00 100%)";
export const colorSemanticDataComparativeMultiGradient10 = "linear-gradient(#5760304d 0%,#57603000 100%)";
export const colorSemanticDataComparativeMultiTransparent1 = "rgba(161, 84, 148, 0.3)";
export const colorSemanticDataComparativeMultiTransparent2 = "rgba(237, 131, 102, 0.3)";
export const colorSemanticDataComparativeMultiTransparent3 = "rgba(213, 107, 123, 0.3)";
export const colorSemanticDataComparativeMultiTransparent4 = "rgba(66, 177, 165, 0.3)";
export const colorSemanticDataComparativeMultiTransparent5 = "rgba(175, 87, 65, 0.3)";
export const colorSemanticDataComparativeMultiTransparent6 = "rgba(147, 61, 76, 0.3)";
export const colorSemanticDataComparativeMultiTransparent7 = "rgba(37, 101, 95, 0.3)";
export const colorSemanticDataComparativeMultiTransparent8 = "rgba(133, 147, 77, 0.3)";
export const colorSemanticDataComparativeMultiTransparent9 = "rgba(103, 52, 93, 0.3)";
export const colorSemanticDataComparativeMultiTransparent10 = "rgba(87, 96, 48, 0.3)";
export const colorSemanticDataComparativeSingle1Default = "#c16fb4";
export const colorSemanticDataComparativeSingle1Alt = "#824377";
export const colorSemanticDataComparativeSingle1Surface = "#f8dff7";
export const colorSemanticDataComparativeSingle1Gradient = "linear-gradient(#c16fb44d 0%,#c16fb400 100%)";
export const colorSemanticDataComparativeSingle1Transparent = "rgba(193, 111, 180, 0.3)";
export const colorSemanticDataComparativeSingle2Default = "#3b9b91";
export const colorSemanticDataComparativeSingle2Alt = "#25655f";
export const colorSemanticDataComparativeSingle2Surface = "#bef1e4";
export const colorSemanticDataComparativeSingle2Gradient = "linear-gradient(#3b9b914d 0%,#3b9b9100 100%)";
export const colorSemanticDataComparativeSingle2Transparent = "rgba(59, 155, 145, 0.3)";
export const colorSemanticDataComparativeSingle3Default = "#d47056";
export const colorSemanticDataComparativeSingle3Alt = "#914330";
export const colorSemanticDataComparativeSingle3Surface = "#ffe1cf";
export const colorSemanticDataComparativeSingle3Gradient = "linear-gradient(#d470564d 0%,#d4705600 100%)";
export const colorSemanticDataComparativeSingle3Transparent = "rgba(212, 112, 86, 0.3)";
export const colorSemanticDataComparativeSingle4Default = "#85934d";
export const colorSemanticDataComparativeSingle4Alt = "#576030";
export const colorSemanticDataComparativeSingle4Surface = "#e1eeb2";
export const colorSemanticDataComparativeSingle4Gradient = "linear-gradient(#85934d4d 0%,#85934d00 100%)";
export const colorSemanticDataComparativeSingle4Transparent = "rgba(133, 147, 77, 0.3)";
export const colorSemanticDataComparativeSingle5Default = "#d56b7b";
export const colorSemanticDataComparativeSingle5Alt = "#933d4c";
export const colorSemanticDataComparativeSingle5Surface = "#ffdcdf";
export const colorSemanticDataComparativeSingle5Gradient = "linear-gradient(#d56b7b4d 0%,#d56b7b00 100%)";
export const colorSemanticDataComparativeSingle5Transparent = "rgba(213, 107, 123, 0.3)";
export const colorSemanticDataSequentialSingle1Highest = "#67345d";
export const colorSemanticDataSequentialSingle1High = "#a15494";
export const colorSemanticDataSequentialSingle1Medium = "#da82ce";
export const colorSemanticDataSequentialSingle1Low = "#f2cdf0";
export const colorSemanticDataSequentialSingle1Lowest = "#feebfd";
export const colorSemanticDataSequentialSingle1Gradient = "linear-gradient(#67345d 0%, #feebfd 100%)";
export const colorSemanticDataSequentialSingle2Highest = "#1a4f49";
export const colorSemanticDataSequentialSingle2High = "#2f7f77";
export const colorSemanticDataSequentialSingle2Medium = "#42b1a5";
export const colorSemanticDataSequentialSingle2Low = "#96e6d7";
export const colorSemanticDataSequentialSingle2Lowest = "#d9fbed";
export const colorSemanticDataSequentialSingle2Gradient = "linear-gradient(#1a4f49 0%, #d9fbed 100%)";
export const colorSemanticDataSequentialSingle3Highest = "#723424";
export const colorSemanticDataSequentialSingle3High = "#af5741";
export const colorSemanticDataSequentialSingle3Medium = "#ed8366";
export const colorSemanticDataSequentialSingle3Low = "#ffc9b4";
export const colorSemanticDataSequentialSingle3Lowest = "#ffede3";
export const colorSemanticDataSequentialSingle3Gradient = "linear-gradient(#723424 0%, #ffede3 100%)";
export const colorSemanticDataSequentialSingle4Highest = "#424922";
export const colorSemanticDataSequentialSingle4High = "#6b773c";
export const colorSemanticDataSequentialSingle4Medium = "#96a74a";
export const colorSemanticDataSequentialSingle4Low = "#bbcd74";
export const colorSemanticDataSequentialSingle4Lowest = "#eef7d0";
export const colorSemanticDataSequentialSingle4Gradient = "linear-gradient(#424922 0%, #eef7d0 100%)";
export const colorSemanticDataSequentialSingle5Highest = "#72313c";
export const colorSemanticDataSequentialSingle5High = "#b15161";
export const colorSemanticDataSequentialSingle5Medium = "#ee7d8d";
export const colorSemanticDataSequentialSingle5Low = "#ffaeb9";
export const colorSemanticDataSequentialSingle5Lowest = "#ffebed";
export const colorSemanticDataSequentialSingle5Gradient = "linear-gradient(#72313c 0%, #ffebed 100%)";
export const colorSemanticDataSequentialDivergentDefault1 = "#824377";
export const colorSemanticDataSequentialDivergentDefault2 = "#a15494";
export const colorSemanticDataSequentialDivergentDefault3 = "#da82ce";
export const colorSemanticDataSequentialDivergentDefault4 = "#f0b1e8";
export const colorSemanticDataSequentialDivergentDefault5 = "#f8dff7";
export const colorSemanticDataSequentialDivergentDefault6 = "#ffe1cf";
export const colorSemanticDataSequentialDivergentDefault7 = "#feaf99";
export const colorSemanticDataSequentialDivergentDefault8 = "#ed8366";
export const colorSemanticDataSequentialDivergentDefault9 = "#af5741";
export const colorSemanticDataSequentialDivergentDefault10 = "#914330";
export const colorSemanticDataSequentialDivergentDefaultGradient = "linear-gradient(#824377 0%, #f8dff7 50%,#ffe1cf 60%, #914330 100%)";
export const colorSemanticDataSequentialDivergentAlt1 = "#933d4c";
export const colorSemanticDataSequentialDivergentAlt2 = "#b15161";
export const colorSemanticDataSequentialDivergentAlt3 = "#ee7d8d";
export const colorSemanticDataSequentialDivergentAlt4 = "#ee7d8d";
export const colorSemanticDataSequentialDivergentAlt5 = "#ffdcdf";
export const colorSemanticDataSequentialDivergentAlt6 = "#bef1e4";
export const colorSemanticDataSequentialDivergentAlt7 = "#75d5c6";
export const colorSemanticDataSequentialDivergentAlt8 = "#42b1a5";
export const colorSemanticDataSequentialDivergentAlt9 = "#2f7f77";
export const colorSemanticDataSequentialDivergentAlt10 = "#25655f";
export const colorSemanticDataSequentialDivergentAltGradient = "linear-gradient(#933d4c 0%, #ffdcdf 50%,#bef1e4 60%, #25655f 100%)";
export const colorSemanticActionsDefault = "#3c57bc";
export const colorSemanticActionsHover = "#4c69d3";
export const colorSemanticActionsActive = "#2b418f";
export const colorSemanticActionsSurface = "rgba(121, 157, 250, 0.2)";
export const colorSemanticActionsSurfaceHover = "rgba(121, 157, 250, 0.1)";
export const colorSemanticActionsSurfaceActive = "rgba(121, 157, 250, 0.3)";
export const colorSemanticActionsNeutralDefault = "#121511";
export const colorSemanticActionsNeutralHover = "rgba(18, 21, 17, 0.75)";
export const colorSemanticActionsNeutralActive = "rgba(18, 21, 17, 0.9)";
export const colorSemanticActionsNeutralSurface = "rgba(18, 21, 17, 0.1)";
export const colorSemanticActionsNeutralSurfaceHover = "rgba(18, 21, 17, 0.05)";
export const colorSemanticActionsNeutralSurfaceActive = "rgba(18, 21, 17, 0.15)";
export const colorSemanticBorderDefault = "#dcd6d1";
export const colorSemanticBorderAlt = "rgba(18, 21, 17, 0.1)";
export const colorSemanticFeedbackCriticalDefault = "#a8303e";
export const colorSemanticFeedbackCriticalHover = "#c04351";
export const colorSemanticFeedbackCriticalActive = "#82222b";
export const colorSemanticFeedbackCriticalSurface = "#ffdfdb";
export const colorSemanticFeedbackCriticalSurfaceAlt = "rgba(251, 115, 127, 0.1)";
export const colorSemanticFeedbackInfoDefault = "#00688e";
export const colorSemanticFeedbackInfoHover = "#007ea9";
export const colorSemanticFeedbackInfoActive = "#004e6b";
export const colorSemanticFeedbackInfoSurface = "#c8f1f5";
export const colorSemanticFeedbackInfoSurfaceAlt = "rgba(0, 175, 217, 0.1)";
export const colorSemanticFeedbackWarningDefault = "#f0bc5f";
export const colorSemanticFeedbackWarningHover = "#f6d58e";
export const colorSemanticFeedbackWarningActive = "#d69300";
export const colorSemanticFeedbackWarningSurface = "#fae6b9";
export const colorSemanticFeedbackWarningSurfaceAlt = "rgba(214, 147, 0, 0.1)";
export const colorSemanticFeedbackWarningForeground = "#121511";
export const colorSemanticFeedbackSmartDefault = "#6d49ad";
export const colorSemanticFeedbackSmartHover = "#8359ce";
export const colorSemanticFeedbackSmartActive = "#533785";
export const colorSemanticFeedbackSmartSurface = "#eae3fe";
export const colorSemanticFeedbackSmartSurfaceAlt = "rgba(176, 141, 249, 0.1)";
export const colorSemanticFeedbackPositiveDefault = "#1a6820";
export const colorSemanticFeedbackPositiveHover = "#31852f";
export const colorSemanticFeedbackPositiveActive = "#1d521c";
export const colorSemanticFeedbackPositiveSurface = "#cdf5ca";
export const colorSemanticFeedbackPositiveSurfaceAlt = "rgba(87, 180, 84, 0.1)";
export const colorBaseFunctionalNeutral0 = "#121511";
export const colorBaseFunctionalNeutral5 = "#2d2f29";
export const colorBaseFunctionalNeutral10 = "#45453f";
export const colorBaseFunctionalNeutral20 = "#605e56";
export const colorBaseFunctionalNeutral30 = "#7d7871";
export const colorBaseFunctionalNeutral40 = "#938e89";
export const colorBaseFunctionalNeutral50 = "#b0aaa5";
export const colorBaseFunctionalNeutral60 = "#c6c0bb";
export const colorBaseFunctionalNeutral70 = "#dcd6d1";
export const colorBaseFunctionalNeutral80 = "#e9e4e0";
export const colorBaseFunctionalNeutral90 = "#f3f0ec";
export const colorBaseFunctionalNeutral95 = "#f9f8f5";
export const colorBaseFunctionalNeutral98 = "#f9f8f5";
export const colorBaseFunctionalNeutral100 = "#fffffe";
export const colorBaseFunctionalNeutralDark0 = "#111011";
export const colorBaseFunctionalNeutralDark5 = "#1b1a1b";
export const colorBaseFunctionalNeutralDark10 = "#262627";
export const colorBaseFunctionalNeutralDark20 = "#2a2a2b";
export const colorBaseFunctionalNeutralDark30 = "#3c3b3c";
export const colorBaseFunctionalNeutralDark40 = "#444344";
export const colorBaseFunctionalNeutralDark50 = "#504f51";
export const colorBaseFunctionalNeutralDark60 = "#5d5c5e";
export const colorBaseFunctionalNeutralDark70 = "#706e71";
export const colorBaseFunctionalNeutralDark80 = "#c0bec2";
export const colorBaseFunctionalNeutralDark90 = "#d5d3d6";
export const colorBaseFunctionalNeutralDark95 = "#ebe9ec";
export const colorBaseFunctionalNeutralDark100 = "#f2f1f2";
export const colorBaseFunctionalRose10 = "#57242c";
export const colorBaseFunctionalRose20 = "#72313c";
export const colorBaseFunctionalRose30 = "#933d4c";
export const colorBaseFunctionalRose40 = "#b15161";
export const colorBaseFunctionalRose50 = "#d56b7b";
export const colorBaseFunctionalRose60 = "#ee7d8d";
export const colorBaseFunctionalRose70 = "#ffaeb9";
export const colorBaseFunctionalRose80 = "#ffc6cc";
export const colorBaseFunctionalRose90 = "#ffdcdf";
export const colorBaseFunctionalRose95 = "#ffebed";
export const colorBaseFunctionalRed10 = "#562625";
export const colorBaseFunctionalRed20 = "#82222b";
export const colorBaseFunctionalRed30 = "#a8303e";
export const colorBaseFunctionalRed40 = "#c04351";
export const colorBaseFunctionalRed50 = "#e25d6a";
export const colorBaseFunctionalRed60 = "#fb737f";
export const colorBaseFunctionalRed70 = "#ffa9a7";
export const colorBaseFunctionalRed80 = "#ffc6c0";
export const colorBaseFunctionalRed90 = "#ffdfdb";
export const colorBaseFunctionalRed95 = "#ffece8";
export const colorBaseFunctionalPeach10 = "#53291e";
export const colorBaseFunctionalPeach20 = "#723424";
export const colorBaseFunctionalPeach30 = "#914330";
export const colorBaseFunctionalPeach40 = "#af5741";
export const colorBaseFunctionalPeach50 = "#d47056";
export const colorBaseFunctionalPeach60 = "#ed8366";
export const colorBaseFunctionalPeach70 = "#feaf99";
export const colorBaseFunctionalPeach80 = "#ffc9b4";
export const colorBaseFunctionalPeach90 = "#ffe1cf";
export const colorBaseFunctionalPeach95 = "#ffede3";
export const colorBaseFunctionalYellow10 = "#4c3011";
export const colorBaseFunctionalYellow20 = "#643f00";
export const colorBaseFunctionalYellow30 = "#7f5300";
export const colorBaseFunctionalYellow40 = "#a06700";
export const colorBaseFunctionalYellow50 = "#bf7c00";
export const colorBaseFunctionalYellow60 = "#d69300";
export const colorBaseFunctionalYellow70 = "#f0bc5f";
export const colorBaseFunctionalYellow80 = "#f6d58e";
export const colorBaseFunctionalYellow90 = "#fae6b9";
export const colorBaseFunctionalYellow95 = "#fff2d1";
export const colorBaseFunctionalLime10 = "#31380d";
export const colorBaseFunctionalLime20 = "#424922";
export const colorBaseFunctionalLime30 = "#576030";
export const colorBaseFunctionalLime40 = "#6b773c";
export const colorBaseFunctionalLime50 = "#85934d";
export const colorBaseFunctionalLime60 = "#96a74a";
export const colorBaseFunctionalLime70 = "#bbcd74";
export const colorBaseFunctionalLime80 = "#cfe08f";
export const colorBaseFunctionalLime90 = "#e1eeb2";
export const colorBaseFunctionalLime95 = "#eef7d0";
export const colorBaseFunctionalGreen10 = "#1c3b1f";
export const colorBaseFunctionalGreen20 = "#1d521c";
export const colorBaseFunctionalGreen30 = "#1a6820";
export const colorBaseFunctionalGreen40 = "#31852f";
export const colorBaseFunctionalGreen50 = "#429f3f";
export const colorBaseFunctionalGreen60 = "#57b454";
export const colorBaseFunctionalGreen70 = "#8fd486";
export const colorBaseFunctionalGreen80 = "#b5e6ab";
export const colorBaseFunctionalGreen90 = "#cdf5ca";
export const colorBaseFunctionalGreen95 = "#e3fadc";
export const colorBaseFunctionalAqua10 = "#003e37";
export const colorBaseFunctionalAqua20 = "#1a4f49";
export const colorBaseFunctionalAqua30 = "#25655f";
export const colorBaseFunctionalAqua40 = "#2f7f77";
export const colorBaseFunctionalAqua50 = "#3b9b91";
export const colorBaseFunctionalAqua60 = "#42b1a5";
export const colorBaseFunctionalAqua70 = "#75d5c6";
export const colorBaseFunctionalAqua80 = "#96e6d7";
export const colorBaseFunctionalAqua90 = "#bef1e4";
export const colorBaseFunctionalAqua95 = "#d9fbed";
export const colorBaseFunctionalBlue10 = "#1b3460";
export const colorBaseFunctionalBlue20 = "#2b418f";
export const colorBaseFunctionalBlue30 = "#3c57bc";
export const colorBaseFunctionalBlue40 = "#4c69d3";
export const colorBaseFunctionalBlue50 = "#6784eb";
export const colorBaseFunctionalBlue60 = "#799dfa";
export const colorBaseFunctionalBlue70 = "#9cc6ff";
export const colorBaseFunctionalBlue80 = "#bcdaff";
export const colorBaseFunctionalBlue90 = "#d7eaff";
export const colorBaseFunctionalBlue95 = "#e7f3ff";
export const colorBaseFunctionalPurple10 = "#3d2c5f";
export const colorBaseFunctionalPurple20 = "#533785";
export const colorBaseFunctionalPurple30 = "#6d49ad";
export const colorBaseFunctionalPurple40 = "#8359ce";
export const colorBaseFunctionalPurple50 = "#9c74e8";
export const colorBaseFunctionalPurple60 = "#b08df9";
export const colorBaseFunctionalPurple70 = "#ccb9fc";
export const colorBaseFunctionalPurple80 = "#dbd1f8";
export const colorBaseFunctionalPurple90 = "#eae3fe";
export const colorBaseFunctionalPurple95 = "#f3efff";
export const colorBaseFunctionalLilac10 = "#522449";
export const colorBaseFunctionalLilac20 = "#67345d";
export const colorBaseFunctionalLilac30 = "#824377";
export const colorBaseFunctionalLilac40 = "#a15494";
export const colorBaseFunctionalLilac50 = "#c16fb4";
export const colorBaseFunctionalLilac60 = "#da82ce";
export const colorBaseFunctionalLilac70 = "#f0b1e8";
export const colorBaseFunctionalLilac80 = "#f2cdf0";
export const colorBaseFunctionalLilac90 = "#f8dff7";
export const colorBaseFunctionalLilac95 = "#feebfd";
export const colorBaseFunctionalCyan10 = "#003b4f";
export const colorBaseFunctionalCyan20 = "#004e6b";
export const colorBaseFunctionalCyan30 = "#00688e";
export const colorBaseFunctionalCyan40 = "#007ea9";
export const colorBaseFunctionalCyan50 = "#0097c4";
export const colorBaseFunctionalCyan60 = "#00afd9";
export const colorBaseFunctionalCyan70 = "#6bd3ef";
export const colorBaseFunctionalCyan80 = "#9ae4f3";
export const colorBaseFunctionalCyan90 = "#c8f1f5";
export const colorBaseFunctionalCyan95 = "#e0f7f9";
export const colorBaseExtendedGray10 = "#45453f";
export const colorBaseExtendedGray20 = "#605e56";
export const colorBaseExtendedGray30 = "#7d7871";
export const colorBaseExtendedGray40 = "#938e89";
export const colorBaseExtendedGray50 = "#b0aaa5";
export const colorBaseExtendedGray60 = "#c6c0bb";
export const colorBaseExtendedGray70 = "#dcd6d1";
export const colorBaseExtendedGray80 = "#e9e4e0";
export const colorBaseExtendedGray90 = "#f3f0ec";
export const colorBaseExtendedGray95 = "#f9f8f5";
export const colorBaseExtendedGray98 = "#f9f8f5";
export const colorBaseExtendedGray100 = "#fffffe";
export const colorBaseExtendedGray05 = "#121511";
export const colorBaseExtendedOrange10 = "#512b1b";
export const colorBaseExtendedOrange20 = "#6e3615";
export const colorBaseExtendedOrange30 = "#8e4718";
export const colorBaseExtendedOrange40 = "#b1580f";
export const colorBaseExtendedOrange50 = "#db6f00";
export const colorBaseExtendedOrange60 = "#f58414";
export const colorBaseExtendedOrange70 = "#ffb35e";
export const colorBaseExtendedOrange80 = "#ffcc8e";
export const colorBaseExtendedOrange90 = "#ffe1ba";
export const colorBaseExtendedOrange95 = "#ffeed7";
export const colorBaseExtendedYellow10 = "#493002";
export const colorBaseExtendedYellow20 = "#604100";
export const colorBaseExtendedYellow30 = "#775400";
export const colorBaseExtendedYellow40 = "#926f00";
export const colorBaseExtendedYellow50 = "#ab8800";
export const colorBaseExtendedYellow60 = "#c3a000";
export const colorBaseExtendedYellow70 = "#e3c512";
export const colorBaseExtendedYellow80 = "#f1d950";
export const colorBaseExtendedYellow90 = "#f9ea94";
export const colorBaseExtendedYellow95 = "#fff7c4";
export const colorBaseExtendedYellow98 = "#fff7c4";
export const colorBaseExtendedGreen10 = "#004024";
export const colorBaseExtendedGreen20 = "#00552c";
export const colorBaseExtendedGreen30 = "#006b36";
export const colorBaseExtendedGreen40 = "#008447";
export const colorBaseExtendedGreen50 = "#00a060";
export const colorBaseExtendedGreen60 = "#00ba72";
export const colorBaseExtendedGreen70 = "#31db92";
export const colorBaseExtendedGreen80 = "#71eeae";
export const colorBaseExtendedGreen90 = "#b2f8cc";
export const colorBaseExtendedGreen95 = "#daffe0";
export const colorBaseExtendedPink10 = "#582435";
export const colorBaseExtendedPink20 = "#772f48";
export const colorBaseExtendedPink30 = "#9a3d5c";
export const colorBaseExtendedPink40 = "#ba486f";
export const colorBaseExtendedPink50 = "#de5f89";
export const colorBaseExtendedPink60 = "#f877a0";
export const colorBaseExtendedPink70 = "#ffaac6";
export const colorBaseExtendedPink80 = "#ffc4d6";
export const colorBaseExtendedPink90 = "#ffdde8";
export const colorBaseExtendedPink95 = "#ffebf0";
export const colorBaseExtendedStone10 = "#45453f";
export const colorBaseExtendedStone20 = "#605e56";
export const colorBaseExtendedStone30 = "#7d7871";
export const colorBaseExtendedStone40 = "#938e89";
export const colorBaseExtendedStone50 = "#b0aaa5";
export const colorBaseExtendedStone60 = "#c6c0bb";
export const colorBaseExtendedStone70 = "#dcd6d1";
export const colorBaseExtendedStone80 = "#e9e4e0";
export const colorBaseExtendedStone90 = "#f3f0ec";
export const colorBaseExtendedStone95 = "#f9f8f5";
export const colorBaseExtendedStone98 = "#f9f8f5";
export const colorBaseTrustpilotBrandPinkPrimary = "#f95a93";
export const colorBaseTrustpilotBrandPinkSecondary = "#4d001c";
export const colorBaseTrustpilotBrandGreenPrimary = "#04da8d";
export const colorBaseTrustpilotBrandGreenSecondary = "#022a1c";
export const colorBaseTrustpilotBrandOrangePrimary = "#fe7a1a";
export const colorBaseTrustpilotBrandOrangeSecondary = "#412612";
export const colorBaseTrustpilotBrandYellowPrimary = "#ffe500";
export const colorBaseTrustpilotBrandYellowSecondary = "#3f3500";
export const colorBaseTrustpilotBrandNeutralBeige = "#fcfbf3";
export const colorBaseTrustpilotBrandNeutralBlack = "#1c1c1c";
export const colorBaseTrustpilotBrandNeutralWhite = "#ffffff";
export const colorBaseTrustpilotStarRatingZero = "#dcdce6";
export const colorBaseTrustpilotStarRatingOne = "#ff3722";
export const colorBaseTrustpilotStarRatingTwo = "#ff8622";
export const colorBaseTrustpilotStarRatingThree = "#ffce00";
export const colorBaseTrustpilotStarRatingFour = "#73cf11";
export const colorBaseTrustpilotStarRatingFive = "#00b67a";
export const elevationSunken = [{"color":"#2d2f291a","type":"innerShadow","x":0,"y":1,"blur":2,"spread":0},{"color":"#605e5626","type":"innerShadow","x":0,"y":2,"blur":2,"spread":0},{"color":"#605e561a","type":"innerShadow","x":0,"y":4,"blur":8,"spread":0}];
export const elevationRaised = [{"color":"#2d2f291a","type":"dropShadow","x":0,"y":1,"blur":2,"spread":0},{"color":"#605e561a","type":"dropShadow","x":0,"y":2,"blur":4,"spread":0},{"color":"#605e561a","type":"dropShadow","x":0,"y":4,"blur":8,"spread":0}];
export const elevationHovering = [{"color":"#2d2f2926","type":"dropShadow","x":0,"y":2,"blur":4,"spread":0},{"color":"#605e5626","type":"dropShadow","x":0,"y":8,"blur":12,"spread":0},{"color":"#605e561a","type":"dropShadow","x":0,"y":4,"blur":8,"spread":0}];
export const elevationOverlay = [{"color":"#2d2f2933","type":"dropShadow","x":0,"y":2,"blur":8,"spread":0},{"color":"#605e5626","type":"dropShadow","x":0,"y":8,"blur":12,"spread":0},{"color":"#605e561a","type":"dropShadow","x":0,"y":12,"blur":16,"spread":0}];
export const typeCaseNone = "none";
export const typeSize60 = 10;
export const typeSize75 = 12;
export const typeSize90 = 14;
export const typeSize100 = 16;
export const typeSize110 = 18;
export const typeSize125 = 20;
export const typeSize150 = 24;
export const typeSize200 = 32;
export const typeSize250 = 40;
export const typeSize300 = 48;
export const typeSize350 = 56;
export const typeSize400 = 64;
export const typeFamilyText = "Trustpilot Sans";
export const typeFamilyDisplay = "Trustpilot Display";
export const typeMarginNone = 0;
export const typeStylesLargeBodyXsFontSize = 10;
export const typeStylesLargeBodyXsTextCase = "none";
export const typeStylesLargeBodyXsFontFamily = "Trustpilot Sans";
export const typeStylesLargeBodyXsFontWeight = 450;
export const typeStylesLargeBodyXsLineHeight = 1.4;
export const typeStylesLargeBodyXsLetterSpacing = 0;
export const typeStylesLargeBodyXsTextDecoration = "none";
export const typeStylesLargeBodyXsParagraphSpacing = 0;
export const typeStylesLargeBodySFontSize = 12;
export const typeStylesLargeBodySTextCase = "none";
export const typeStylesLargeBodySFontFamily = "Trustpilot Sans";
export const typeStylesLargeBodySFontWeight = 450;
export const typeStylesLargeBodySLineHeight = 1.4;
export const typeStylesLargeBodySLetterSpacing = 0;
export const typeStylesLargeBodySTextDecoration = "none";
export const typeStylesLargeBodySParagraphSpacing = 0;
export const typeStylesLargeBodyMFontSize = 14;
export const typeStylesLargeBodyMTextCase = "none";
export const typeStylesLargeBodyMFontFamily = "Trustpilot Sans";
export const typeStylesLargeBodyMFontWeight = 450;
export const typeStylesLargeBodyMLineHeight = 1.4;
export const typeStylesLargeBodyMLetterSpacing = 0;
export const typeStylesLargeBodyMTextDecoration = "none";
export const typeStylesLargeBodyMParagraphSpacing = 0;
export const typeStylesLargeBodyLFontSize = 16;
export const typeStylesLargeBodyLTextCase = "none";
export const typeStylesLargeBodyLFontFamily = "Trustpilot Sans";
export const typeStylesLargeBodyLFontWeight = 450;
export const typeStylesLargeBodyLLineHeight = 1.4;
export const typeStylesLargeBodyLLetterSpacing = 0;
export const typeStylesLargeBodyLTextDecoration = "none";
export const typeStylesLargeBodyLParagraphSpacing = 0;
export const typeStylesLargeBodyXlFontSize = 18;
export const typeStylesLargeBodyXlTextCase = "none";
export const typeStylesLargeBodyXlFontFamily = "Trustpilot Sans";
export const typeStylesLargeBodyXlFontWeight = 450;
export const typeStylesLargeBodyXlLineHeight = 1.4;
export const typeStylesLargeBodyXlLetterSpacing = 0;
export const typeStylesLargeBodyXlTextDecoration = "none";
export const typeStylesLargeBodyXlParagraphSpacing = 0;
export const typeStylesLargeDisplayXsFontSize = 24;
export const typeStylesLargeDisplayXsTextCase = "none";
export const typeStylesLargeDisplayXsFontFamily = "Trustpilot Display";
export const typeStylesLargeDisplayXsFontWeight = 800;
export const typeStylesLargeDisplayXsLineHeight = 1.2;
export const typeStylesLargeDisplayXsLetterSpacing = 0;
export const typeStylesLargeDisplayXsTextDecoration = "none";
export const typeStylesLargeDisplayXsParagraphSpacing = 0;
export const typeStylesLargeDisplaySFontSize = 32;
export const typeStylesLargeDisplaySTextCase = "none";
export const typeStylesLargeDisplaySFontFamily = "Trustpilot Display";
export const typeStylesLargeDisplaySFontWeight = 800;
export const typeStylesLargeDisplaySLineHeight = 1.3;
export const typeStylesLargeDisplaySLetterSpacing = 0;
export const typeStylesLargeDisplaySTextDecoration = "none";
export const typeStylesLargeDisplaySParagraphSpacing = 0;
export const typeStylesLargeDisplayMFontSize = 40;
export const typeStylesLargeDisplayMTextCase = "none";
export const typeStylesLargeDisplayMFontFamily = "Trustpilot Display";
export const typeStylesLargeDisplayMFontWeight = 800;
export const typeStylesLargeDisplayMLineHeight = 1.3;
export const typeStylesLargeDisplayMLetterSpacing = 0;
export const typeStylesLargeDisplayMTextDecoration = "none";
export const typeStylesLargeDisplayMParagraphSpacing = 0;
export const typeStylesLargeDisplayLFontSize = 48;
export const typeStylesLargeDisplayLTextCase = "none";
export const typeStylesLargeDisplayLFontFamily = "Trustpilot Display";
export const typeStylesLargeDisplayLFontWeight = 800;
export const typeStylesLargeDisplayLLineHeight = 1.3;
export const typeStylesLargeDisplayLLetterSpacing = 0;
export const typeStylesLargeDisplayLTextDecoration = "none";
export const typeStylesLargeDisplayLParagraphSpacing = 0;
export const typeStylesLargeDisplayXlFontSize = 56;
export const typeStylesLargeDisplayXlTextCase = "none";
export const typeStylesLargeDisplayXlFontFamily = "Trustpilot Display";
export const typeStylesLargeDisplayXlFontWeight = 800;
export const typeStylesLargeDisplayXlLineHeight = 1.3;
export const typeStylesLargeDisplayXlLetterSpacing = 0;
export const typeStylesLargeDisplayXlTextDecoration = "none";
export const typeStylesLargeDisplayXlParagraphSpacing = 0;
export const typeStylesLargeHeadingXxxsFontSize = 12;
export const typeStylesLargeHeadingXxxsTextCase = "none";
export const typeStylesLargeHeadingXxxsFontFamily = "Trustpilot Sans";
export const typeStylesLargeHeadingXxxsFontWeight = 575;
export const typeStylesLargeHeadingXxxsLineHeight = 1.2;
export const typeStylesLargeHeadingXxxsLetterSpacing = 0;
export const typeStylesLargeHeadingXxxsTextDecoration = "none";
export const typeStylesLargeHeadingXxxsParagraphSpacing = 0;
export const typeStylesLargeHeadingXxsFontSize = 14;
export const typeStylesLargeHeadingXxsTextCase = "none";
export const typeStylesLargeHeadingXxsFontFamily = "Trustpilot Sans";
export const typeStylesLargeHeadingXxsFontWeight = 575;
export const typeStylesLargeHeadingXxsLineHeight = 1.2;
export const typeStylesLargeHeadingXxsLetterSpacing = 0;
export const typeStylesLargeHeadingXxsTextDecoration = "none";
export const typeStylesLargeHeadingXxsParagraphSpacing = 0;
export const typeStylesLargeHeadingXsFontSize = 16;
export const typeStylesLargeHeadingXsTextCase = "none";
export const typeStylesLargeHeadingXsFontFamily = "Trustpilot Sans";
export const typeStylesLargeHeadingXsFontWeight = 575;
export const typeStylesLargeHeadingXsLineHeight = 1.2;
export const typeStylesLargeHeadingXsLetterSpacing = 0;
export const typeStylesLargeHeadingXsTextDecoration = "none";
export const typeStylesLargeHeadingXsParagraphSpacing = 0;
export const typeStylesLargeHeadingSFontSize = 18;
export const typeStylesLargeHeadingSTextCase = "none";
export const typeStylesLargeHeadingSFontFamily = "Trustpilot Sans";
export const typeStylesLargeHeadingSFontWeight = 575;
export const typeStylesLargeHeadingSLineHeight = 1.2;
export const typeStylesLargeHeadingSLetterSpacing = 0;
export const typeStylesLargeHeadingSTextDecoration = "none";
export const typeStylesLargeHeadingSParagraphSpacing = 0;
export const typeStylesLargeHeadingMFontSize = 24;
export const typeStylesLargeHeadingMTextCase = "none";
export const typeStylesLargeHeadingMFontFamily = "Trustpilot Sans";
export const typeStylesLargeHeadingMFontWeight = 575;
export const typeStylesLargeHeadingMLineHeight = 1.2;
export const typeStylesLargeHeadingMLetterSpacing = 0;
export const typeStylesLargeHeadingMTextDecoration = "none";
export const typeStylesLargeHeadingMParagraphSpacing = 0;
export const typeStylesLargeHeadingLFontSize = 32;
export const typeStylesLargeHeadingLTextCase = "none";
export const typeStylesLargeHeadingLFontFamily = "Trustpilot Sans";
export const typeStylesLargeHeadingLFontWeight = 675;
export const typeStylesLargeHeadingLLineHeight = 1.2;
export const typeStylesLargeHeadingLLetterSpacing = 0;
export const typeStylesLargeHeadingLTextDecoration = "none";
export const typeStylesLargeHeadingLParagraphSpacing = 0;
export const typeStylesLargeHeadingXlFontSize = 40;
export const typeStylesLargeHeadingXlTextCase = "none";
export const typeStylesLargeHeadingXlFontFamily = "Trustpilot Sans";
export const typeStylesLargeHeadingXlFontWeight = 675;
export const typeStylesLargeHeadingXlLineHeight = 1.2;
export const typeStylesLargeHeadingXlLetterSpacing = 0;
export const typeStylesLargeHeadingXlTextDecoration = "none";
export const typeStylesLargeHeadingXlParagraphSpacing = 0;
export const typeStylesSmallBodyXsFontSize = 10;
export const typeStylesSmallBodyXsTextCase = "none";
export const typeStylesSmallBodyXsFontFamily = "Trustpilot Sans";
export const typeStylesSmallBodyXsFontWeight = 450;
export const typeStylesSmallBodyXsLineHeight = 1.4;
export const typeStylesSmallBodyXsLetterSpacing = 0;
export const typeStylesSmallBodyXsTextDecoration = "none";
export const typeStylesSmallBodyXsParagraphSpacing = 0;
export const typeStylesSmallBodySFontSize = 12;
export const typeStylesSmallBodySTextCase = "none";
export const typeStylesSmallBodySFontFamily = "Trustpilot Sans";
export const typeStylesSmallBodySFontWeight = 450;
export const typeStylesSmallBodySLineHeight = 1.4;
export const typeStylesSmallBodySLetterSpacing = 0;
export const typeStylesSmallBodySTextDecoration = "none";
export const typeStylesSmallBodySParagraphSpacing = 0;
export const typeStylesSmallBodyMFontSize = 14;
export const typeStylesSmallBodyMTextCase = "none";
export const typeStylesSmallBodyMFontFamily = "Trustpilot Sans";
export const typeStylesSmallBodyMFontWeight = 450;
export const typeStylesSmallBodyMLineHeight = 1.4;
export const typeStylesSmallBodyMLetterSpacing = 0;
export const typeStylesSmallBodyMTextDecoration = "none";
export const typeStylesSmallBodyMParagraphSpacing = 0;
export const typeStylesSmallBodyLFontSize = 16;
export const typeStylesSmallBodyLTextCase = "none";
export const typeStylesSmallBodyLFontFamily = "Trustpilot Sans";
export const typeStylesSmallBodyLFontWeight = 450;
export const typeStylesSmallBodyLLineHeight = 1.4;
export const typeStylesSmallBodyLLetterSpacing = 0;
export const typeStylesSmallBodyLTextDecoration = "none";
export const typeStylesSmallBodyLParagraphSpacing = 0;
export const typeStylesSmallBodyXlFontSize = 18;
export const typeStylesSmallBodyXlTextCase = "none";
export const typeStylesSmallBodyXlFontFamily = "Trustpilot Sans";
export const typeStylesSmallBodyXlFontWeight = 450;
export const typeStylesSmallBodyXlLineHeight = 1.4;
export const typeStylesSmallBodyXlLetterSpacing = 0;
export const typeStylesSmallBodyXlTextDecoration = "none";
export const typeStylesSmallBodyXlParagraphSpacing = 0;
export const typeStylesSmallDisplayXsFontSize = 18;
export const typeStylesSmallDisplayXsTextCase = "none";
export const typeStylesSmallDisplayXsFontFamily = "Trustpilot Display";
export const typeStylesSmallDisplayXsFontWeight = 800;
export const typeStylesSmallDisplayXsLineHeight = 1.3;
export const typeStylesSmallDisplayXsLetterSpacing = 0;
export const typeStylesSmallDisplayXsTextDecoration = "none";
export const typeStylesSmallDisplayXsParagraphSpacing = 0;
export const typeStylesSmallDisplaySFontSize = 20;
export const typeStylesSmallDisplaySTextCase = "none";
export const typeStylesSmallDisplaySFontFamily = "Trustpilot Display";
export const typeStylesSmallDisplaySFontWeight = 800;
export const typeStylesSmallDisplaySLineHeight = 1.3;
export const typeStylesSmallDisplaySLetterSpacing = 0;
export const typeStylesSmallDisplaySTextDecoration = "none";
export const typeStylesSmallDisplaySParagraphSpacing = 0;
export const typeStylesSmallDisplayMFontSize = 24;
export const typeStylesSmallDisplayMTextCase = "none";
export const typeStylesSmallDisplayMFontFamily = "Trustpilot Display";
export const typeStylesSmallDisplayMFontWeight = 800;
export const typeStylesSmallDisplayMLineHeight = 1.3;
export const typeStylesSmallDisplayMLetterSpacing = 0;
export const typeStylesSmallDisplayMTextDecoration = "none";
export const typeStylesSmallDisplayMParagraphSpacing = 0;
export const typeStylesSmallDisplayLFontSize = 32;
export const typeStylesSmallDisplayLTextCase = "none";
export const typeStylesSmallDisplayLFontFamily = "Trustpilot Display";
export const typeStylesSmallDisplayLFontWeight = 800;
export const typeStylesSmallDisplayLLineHeight = 1.3;
export const typeStylesSmallDisplayLLetterSpacing = 0;
export const typeStylesSmallDisplayLTextDecoration = "none";
export const typeStylesSmallDisplayLParagraphSpacing = 0;
export const typeStylesSmallDisplayXlFontSize = 40;
export const typeStylesSmallDisplayXlTextCase = "none";
export const typeStylesSmallDisplayXlFontFamily = "Trustpilot Display";
export const typeStylesSmallDisplayXlFontWeight = 800;
export const typeStylesSmallDisplayXlLineHeight = 1.3;
export const typeStylesSmallDisplayXlLetterSpacing = 0;
export const typeStylesSmallDisplayXlTextDecoration = "none";
export const typeStylesSmallDisplayXlParagraphSpacing = 0;
export const typeStylesSmallHeadingXxxsFontSize = 12;
export const typeStylesSmallHeadingXxxsTextCase = "none";
export const typeStylesSmallHeadingXxxsFontFamily = "Trustpilot Sans";
export const typeStylesSmallHeadingXxxsFontWeight = 575;
export const typeStylesSmallHeadingXxxsLineHeight = 1.2;
export const typeStylesSmallHeadingXxxsLetterSpacing = 0;
export const typeStylesSmallHeadingXxxsTextDecoration = "none";
export const typeStylesSmallHeadingXxxsParagraphSpacing = 0;
export const typeStylesSmallHeadingXxsFontSize = 14;
export const typeStylesSmallHeadingXxsTextCase = "none";
export const typeStylesSmallHeadingXxsFontFamily = "Trustpilot Sans";
export const typeStylesSmallHeadingXxsFontWeight = 575;
export const typeStylesSmallHeadingXxsLineHeight = 1.2;
export const typeStylesSmallHeadingXxsLetterSpacing = 0;
export const typeStylesSmallHeadingXxsTextDecoration = "none";
export const typeStylesSmallHeadingXxsParagraphSpacing = 0;
export const typeStylesSmallHeadingXsFontSize = 16;
export const typeStylesSmallHeadingXsTextCase = "none";
export const typeStylesSmallHeadingXsFontFamily = "Trustpilot Sans";
export const typeStylesSmallHeadingXsFontWeight = 575;
export const typeStylesSmallHeadingXsLineHeight = 1.2;
export const typeStylesSmallHeadingXsLetterSpacing = 0;
export const typeStylesSmallHeadingXsTextDecoration = "none";
export const typeStylesSmallHeadingXsParagraphSpacing = 0;
export const typeStylesSmallHeadingSFontSize = 18;
export const typeStylesSmallHeadingSTextCase = "none";
export const typeStylesSmallHeadingSFontFamily = "Trustpilot Sans";
export const typeStylesSmallHeadingSFontWeight = 575;
export const typeStylesSmallHeadingSLineHeight = 1.2;
export const typeStylesSmallHeadingSLetterSpacing = 0;
export const typeStylesSmallHeadingSTextDecoration = "none";
export const typeStylesSmallHeadingSParagraphSpacing = 0;
export const typeStylesSmallHeadingMFontSize = 20;
export const typeStylesSmallHeadingMTextCase = "none";
export const typeStylesSmallHeadingMFontFamily = "Trustpilot Sans";
export const typeStylesSmallHeadingMFontWeight = 575;
export const typeStylesSmallHeadingMLineHeight = 1.2;
export const typeStylesSmallHeadingMLetterSpacing = 0;
export const typeStylesSmallHeadingMTextDecoration = "none";
export const typeStylesSmallHeadingMParagraphSpacing = 0;
export const typeStylesSmallHeadingLFontSize = 24;
export const typeStylesSmallHeadingLTextCase = "none";
export const typeStylesSmallHeadingLFontFamily = "Trustpilot Sans";
export const typeStylesSmallHeadingLFontWeight = 675;
export const typeStylesSmallHeadingLLineHeight = 1.2;
export const typeStylesSmallHeadingLLetterSpacing = 0;
export const typeStylesSmallHeadingLTextDecoration = "none";
export const typeStylesSmallHeadingLParagraphSpacing = 0;
export const typeStylesSmallHeadingXlFontSize = 32;
export const typeStylesSmallHeadingXlTextCase = "none";
export const typeStylesSmallHeadingXlFontFamily = "Trustpilot Sans";
export const typeStylesSmallHeadingXlFontWeight = 675;
export const typeStylesSmallHeadingXlLineHeight = 1.2;
export const typeStylesSmallHeadingXlLetterSpacing = 0;
export const typeStylesSmallHeadingXlTextDecoration = "none";
export const typeStylesSmallHeadingXlParagraphSpacing = 0;
export const typeWeightBold = 675;
export const typeWeightRegular = 450;
export const typeWeightSemibold = 575;
export const typeWeightExtrabold = 800;
export const typeDecorationNone = "none";
export const typeLineHeightCompact = 1.2;
export const typeLineHeightMedium = 1.3;
export const typeLineHeightSpacious = 1.4;
export const typeLetterSpacingCompact = "-1%";
export const typeLetterSpacingMedium = 0;
export const typeLetterSpacingSpacious = "1%";
export const opacity0 = 0;
export const opacity5 = 0.05;
export const opacity10 = 0.1;
export const opacity15 = 0.15;
export const opacity20 = 0.2;
export const opacity30 = 0.3;
export const opacity50 = 0.5;
export const opacity75 = 0.75;
export const opacity90 = 0.9;
export const spacingNone = 0;
export const spacingXxxs = 2;
export const spacingXxs = 4;
export const spacingXs = 8;
export const spacingS = 12;
export const spacingM = 16;
export const spacingL = 24;
export const spacingXl = 32;
export const spacingXxl = 40;
export const spacingXxxl = 64;
export const spacingXxxxl = 80;
export const boxShadow30 = {"x":0,"y":0,"blur":8,"type":"dropShadow","color":"#0000004d","spread":0};
export const boxShadow80 = {"x":0,"y":0,"blur":8,"type":"dropShadow","color":"#000000cc","spread":0};
export const borderRadiusNone = 0;
export const borderRadiusXs = 2;
export const borderRadiusS = 4;
export const borderRadiusM = 8;
export const borderRadiusL = 16;
export const borderRadiusXl = 24;
export const borderRadiusXxl = 32;
export const borderRadiusFull = 9999;
